
// Define un punto de la línea.
export class Dot {
	public lat = 0;		// Latitud.
	public lng = 0;		// Longitud.
	public ele = 0;		// Elevación.
}

export class CoorMaps {
	public static Data = 0;
	public static Lat = 1;
	public static Lng = 2;
	public static Elevation = 3;

	public static Offset = 4;

	public static MaxElevation = 35;
	public static MaxElevationDes = 25;

	private static PRESICION = 100000;

	// Actualizado = 0, NO actualizado = 1.
	public upd = 1;

	// Angulos sobre sus dos puntos adyacences.
	public ang = 0;

	public dots: Dot[] = [];

	// ########## Métodos.
	constructor(lat: number, lng: number) {
		this.dots = [];
		let d = new Dot();
		d.lat = Math.round(lat * CoorMaps.PRESICION) / CoorMaps.PRESICION;
		d.lng = Math.round(lng * CoorMaps.PRESICION) / CoorMaps.PRESICION;
		this.upd = 1;
		this.dots.push(d);
	}
}